import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Slider from 'react-slick';
import { PaymentPromo } from './paymentPromo';
import { imgUrlConverter, packageProductsSliderSettings } from '../../util';
import { CARD_LABELS } from './constants'
import { formatPrice } from "../../util/formatPrice";
import { getUniquePackageItems, getUniquePackageItemsWithSubProducts } from './utils'

const ProductOverView = React.memo(
	({
		packageItems,
		productDetails,
		hsPaymentPromo,
		activePkgIdx,
		onCustomizeClick,
		altImage,
		fromGradPackages,
		googleAnalytics
	}) => {
		const priceValue = productDetails[fromGradPackages ? 'packagePrice' : 'retailPrice']
		const savePrice = formatPrice(productDetails?.packageDiscountAmount, productDetails?.currencyCode)
		const price = formatPrice(priceValue, productDetails?.currencyCode)
		const activePackageIndex = productDetails?.productOsr

		const uniquePackageItems = getUniquePackageItems(packageItems, activePackageIndex)
		const uniquePackageItemsWithSubProducts = getUniquePackageItemsWithSubProducts(packageItems, activePackageIndex)

		const getIncludedProductsItems = () => (
			<ul className='included-product-list mb-0'>
				{uniquePackageItems.map((packageItem, index) =>
					<li
						className='included-product-item mb-1 mr-2 ml-3'
						key={`${packageItem.name}${index}`}>
						{packageItem.quantity > 1 && <span className='item-ammount'>{`${packageItem.quantity} `}</span>}
						{packageItem?.name}
					</li>
				)}
			</ul>
		)

		const getIncludedProductsItemsWithSubProducts = () => (
			<ul>
				{uniquePackageItemsWithSubProducts.map((packageItem, index) => (
					<li
						className='included-product-item mb-1 mr-2 ml-3'
						key={`${packageItem.name}${index}`}>
						<div>
							{packageItem.quantity > 1 && <span className='item-ammount'>{`${packageItem.quantity} `}</span>}
							{packageItem?.name}
						</div>
						{
							packageItem?.subItems?.map(subProduct => (
								<div
									className='ml-2 fontSizeSM'
									key={subProduct?.productOsr}>
									{subProduct?.displayName}
								</div>
							))
						}
					</li>
				))}
			</ul>
		)

		return (
			<>
				<div className='product-categories mb-3 px-2'>
					<Slider
						{...packageProductsSliderSettings}
						className='carousel'
						key={activePkgIdx}>
						{packageItems.length > 0 &&
							packageItems
								.map((packageItem, index) => {
									if (packageItem?.personalizedAnnouncementItems?.length) {
										return packageItem?.personalizedAnnouncementItems.map(
											(item, itemIndex) => (
												productDetails?.prodRefCode === item?.prodRefcode &&
												<div key={index + '-' + itemIndex}>
													<LazyLoadImage
														src={imgUrlConverter(item?.imageUrl, 'product_md')}
														alt={item?.displayName}
														onError={(e) => (e.target.src = altImage)}
													/>
													<div className='packageItems-productName'>
														<div
															className='package-item-name fontSizeXS'
															title={item?.displayName + '.'}>
															{item?.displayName}
														</div>
													</div>
												</div>
											)
										);
									} else {
										return (
											packageItem.displayName !== "freeProducts" &&
											<div key={index}>
												<LazyLoadImage
													src={imgUrlConverter(
														packageItem?.imageUrl || altImage,
														'product_md'
													)}
													alt={packageItem?.displayName}
													onError={(e) => e.target.src = altImage}
												/>
												<div className='packageItems-productName'>
													<div
														className='package-item-name fontSizeXS'
														title={packageItem?.displayName + '.'}>
														{packageItem?.displayName}
													</div>
												</div>
											</div>
										);
									}
								})}
					</Slider>
				</div>
				<div className='title'>{productDetails?.displayName}</div>
				<div className='price-row'>
					{hsPaymentPromo ? (
						<PaymentPromo
							hsPaymentPromo={hsPaymentPromo}
							product={productDetails}
							showAfterPay={true}
							googleAnalytics={googleAnalytics}
						/>
					) : (
						<div className='price'>{price}</div>
					)}
				</div>
				{packageItems.length > 0 &&
					packageItems.filter((packageItem) => !packageItem?.personalizedAnnouncementItems)
						.map((packageItem) => {
							if (packageItem?.displayName === "freeProducts") {
								return packageItem?.packageProductAvailability?.map((product) => (
									productDetails?.prodRefCode === product?.packageOsr && <div className='font-weight-bold my-2'>{product?.display}</div>
								))
							}
						})
				}
				<div className='font-weight-bold my-2'>{productDetails?.repMessage}</div>
				<div className='action-button'>
					<div
						className='btn btn-primary btn-sm'
						onClick={() => {
							onCustomizeClick(productDetails);
						}}>
						{CARD_LABELS.CUSTOMIZE}
					</div>
				</div>
				{fromGradPackages && savePrice && (
					<div style={{ marginTop: '10px' }} className='price-row'>
						{CARD_LABELS.SAVE(savePrice)}
					</div>
				)}
				<div className='details my-2'>
					<div className='font-weight-bold'>{CARD_LABELS.INCLUDED}</div>
					{getIncludedProductsItems()}
					{getIncludedProductsItemsWithSubProducts()}
				</div>
			</>
		);
	}
);
export default ProductOverView;
